import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LinesOfAuthorityService } from 'api-services/lines-of-authority.service';
import { UserAppointmentService } from 'api-services/user-appointment.service';
import { CarrierService } from 'components/carrier/services/carrier.service';
import { ValidatorHelper } from 'components/custom-validators/validators.helper';
import { ConfirmDialogComponent } from 'components/shared-component/confirm-dialog/confirm-dialog.component';
import { State } from 'models';
import { carrierAttributes } from 'models/carrierAttributes.model';
import { contactcode } from 'models/contactcode.model';
// import { Validators } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { SharedService } from 'services';
import { ngbModalOptions } from 'shared/constant';

@Component({
  selector: 'app-add-appointer-information',
  templateUrl: './add-appointer-information.component.html',
  styleUrls: ['./add-appointer-information.component.css']
})
export class AddAppointerInformationComponent implements OnInit {
  masterStates: State[] = [] as State[];
  appointerStates: State[] = [] as State[];
  contactCodeData: contactcode[] = [] as contactcode[];
  paymentCodeData: contactcode[] = [] as contactcode[];
  appointerData: carrierAttributes;
  subscription: Subscription[] = [];
  carrierData: any;
  carrierAttributeId: number;
  mask: any[] = [/[2-9]{1}/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  @Output() showManage: EventEmitter<string> = new EventEmitter<string>();
  @Output() closePopup: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isEdit;
  @Input() isPopupView;
  @Input() selectedAppointmentWith;
  errorMessages: any;
  appointerForm!: FormGroup;
  loggedInTenantId = this.sharedService.getKey('tenantId');

  constructor(private fb: FormBuilder, private carrierService: CarrierService, private modalService: NgbModal, private appointmentService: UserAppointmentService, public sharedService: SharedService, private loaService: LinesOfAuthorityService) { }

  ngOnInit(): void {

    this.appointerForm = this.fb.group({
      carrierAttributesId: [],
      carrierId: [],
      stateId: [0, Validators.required],
      stateCompanyId: ['', [Validators.required, Validators.maxLength(15)]],
      residenceTypeId: [0, Validators.required],
      licenseNumber: ['', [Validators.required, Validators.maxLength(25)]],
      appointerTitle: ['', [Validators.required, Validators.maxLength(25)]],
      firstName: ['', [Validators.required, Validators.maxLength(25)]],
      lastName: ['', [Validators.required, Validators.maxLength(100)]],
      addressCode: ['02'],
      addressLine1: ['', [Validators.required, Validators.maxLength(50)]],
      addressLine2: ['', Validators.maxLength(50)],
      stateCode: ['', [Validators.required, Validators.maxLength(10)]],
      zip: ['', [Validators.required, Validators.pattern(/^\d{5}(-\d{4})?$/), Validators.minLength(5), Validators.maxLength(10)]],
      city: ['', [Validators.required, Validators.maxLength(35)]],
      phoneCode: ['02'],
      phoneNumber: ['', [Validators.required, ValidatorHelper.phonePattern]],
      emailCode: ['02'],
      emailAddress: ['', [Validators.required, Validators.maxLength(50), ValidatorHelper.emailPattern,]],
      authFirmName: ['', Validators.maxLength(100)],
      preparerCode: ['S', Validators.maxLength(100)],
      complianceOfficer: ['', Validators.maxLength(100)],
      paymentType: ['02', [Validators.required, Validators.maxLength(10)]],
      accountId: ['001', [Validators.required, Validators.maxLength(15)]],
      appointerResidenceStateCode: ['', [Validators.required, Validators.maxLength(10)]],
      appointerResidenceStateLicenseId: ['', [Validators.required, Validators.maxLength(25)]],
      appointerResidenceStateCompanyId: ['', [Validators.required, Validators.maxLength(15)]],
      userId: []
    });

    this.loadCodes();
    this.loadMasterStates();
    this.getCarrierData();
    // this.getCarrierData();
  }

  loadMasterStates() {
    this.loaService.getAllStates().subscribe(
      response => {
        this.masterStates = response;
        if (this.isEdit != "add-appointer") {
          this.appointerStates = this.masterStates;
        } else {
          this.isPopupView ? this.getAppointerInfo() : '';
        }
      }
    )
  }

  loadAppointerStates() {
    this.loaService.getStatestoAddAppointer(this.carrierData.carrierId).subscribe(
      response => {
        this.appointerStates = response;
        this.isPopupView ? '' : this.getCarrierInfo();
        this.getAppointerData();
      }
    )
  }

  loadCodes() {
    this.contactCodeData = [
      { codeText: "01", codeValue: "01" },
      { codeText: "02", codeValue: "02" },
      { codeText: "03", codeValue: "03" }
    ];
    this.paymentCodeData = [
      { codeText: "None", codeValue: "00" },
      { codeText: "Escrow (check)", codeValue: "01" },
      { codeText: "Pre-established direct debit account (EFT)", codeValue: "02" },
      { codeText: "Credit Card", codeValue: "03" },
      { codeText: "Electronic Check Payment", codeValue: "04" }
    ];
  }

  getCarrierData() {

    var loggedInTenantId = parseInt(this.sharedService.getKey('tenantId'));
    let request = {
      tenantId: loggedInTenantId,
      isArchive: false
    }
    this.carrierService.getCarrierListForSettings(request).subscribe(data => {
      this.carrierData = data[0];

      if (this.isEdit == "add-appointer" || this.isEdit == "copy-appointer") {
        this.loadAppointerStates();
      } else {
        this.getAppointerData();
      }

    });
  }

  getCarrierInfo() {
    this.subscription.push(this.carrierService.getCarrier(this.carrierData.carrierId).subscribe(data => {
      //LV added on March 20,2026 - Disable control if Carrier have resident Details
      if (data.carrierResidentStateCode)
        this.appointerForm.get('appointerResidenceStateCode').disable();
      if (data.carrierResidentLicenseNumber)
        this.appointerForm.get('appointerResidenceStateLicenseId').disable();
      if (data.carrierResidentStateCompanyId)
        this.appointerForm.get('appointerResidenceStateCompanyId').disable();

      this.selectedAppointmentWith = {
        appointerResidenceStateCode: data.carrierResidentStateCode,
        appointerResidenceStateLicenseId: data.carrierResidentLicenseNumber,
        appointerResidenceStateCompanyId: data.carrierResidentStateCompanyId
      }
      this.appointerForm.patchValue(this.selectedAppointmentWith);
    }));
  }

  getAppointerData() {
    this.subscription.push(this.carrierService.editAppointer.subscribe(obj => {
      if (obj != '') {
        //console.log(obj);
        //console.log(obj.carrierAttributesId);
        this.appointerData = obj;
        // this.appointerForm.patchValue(obj);
        this.resetFormData();
      }
      else {
        this.appointerData = null;
        this.resetFormData()
        // this.appointerForm.reset();
        //this.appointerForm.patchValue({
        //  paymentType: '00'
        //});
      }
    }));
  }

  onSubmit(): void {
    this.errorMessages = [];
    this.appointerForm.controls['carrierAttributesId'].setValue(this.appointerData != null ? this.appointerData.carrierAttributesId : 0);
    this.appointerForm.controls['carrierId'].setValue(this.carrierData != null ? this.carrierData.carrierId : 0);
    this.appointerForm.controls['userId'].setValue(parseInt(this.sharedService.getKey('Id')));
    this.appointerForm.controls['addressCode'].setValue("02");
    this.appointerForm.controls['phoneCode'].setValue("02");
    this.appointerForm.controls['emailCode'].setValue("02");
    if (this.appointerForm.valid) {
      const formData = this.appointerForm.getRawValue();
      this.carrierService.manageCarrierAttributes(formData).subscribe(
        (response: any) => {
          if (response.id > 0) {
            this.isPopupView ? this.closePopup.next(true) : this.targetLink('edit-carrier');
          }
          this.sharedService.showToastMessage(response.rtnMessage);
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  targetLink(tab) {
    this.showManage.emit(tab);
  }

  resetFormData(isActiveCondition: boolean = true) {
    if (this.isEdit == "edit-appointer" && isActiveCondition) {
      this.appointerForm.patchValue(this.appointerData);
      this.appointerForm.controls['paymentType'].setValue("02");
    }
    else if (this.isEdit == "copy-appointer" && isActiveCondition) {
      this.appointerForm.patchValue(this.appointerData);
      this.appointerForm.controls['paymentType'].setValue("02");
      this.appointerForm.controls['stateId'].setValue(null);
      this.appointerForm.controls['stateCompanyId'].setValue(null);
      this.appointerForm.controls['licenseNumber'].setValue(null);
      this.appointerForm.controls['residenceTypeId'].setValue(null);
      this.appointerData = null;
    } else {

      if (this.isEdit == "copy-appointer") {
        this.selectedAppointmentWith.firstName = this.appointerForm.value.firstName;
        this.selectedAppointmentWith.lastName = this.appointerForm.value.lastName;
        this.selectedAppointmentWith.appointerTitle = this.appointerForm.value.appointerTitle;
        this.selectedAppointmentWith.complianceOfficer = this.appointerForm.value.complianceOfficer;
      }

      this.appointerForm.reset();

      if (this.selectedAppointmentWith) {
        this.appointerForm.patchValue(this.selectedAppointmentWith);
      }

      this.selectedAppointmentWith.residenceTypeId == 0 ? this.appointerForm.get('residenceTypeId')!.setValue(null) : '';
      this.appointerForm.controls['paymentType'].setValue("02");
      this.appointerForm.get("accountId")!.setValue("001");
      this.appointerForm.get("preparerCode")!.setValue("S");
    }
    // this.selectedAppointmentWith ? this.appointerForm.get('stateId')!.setValue(this.selectedAppointmentWith.stateId) : '';
  

}

getAppointerInfo(){
  // if(this.isEdit == "add-appointer"){
  this.appointmentService.getCarrierDetailforAppointer(this.loggedInTenantId, this.carrierData.carrierId, this.masterStates.find(el => el.stateId == this.appointerForm.value.stateId).stateCode).subscribe(res => {
    this.selectedAppointmentWith = res;
    //LV added on March 20,2026 - Allowing Clear Spring to Add Resident details by Manually if they don't have Resident License details
    this.selectedAppointmentWith.appointerResidenceStateCode = this.appointerForm.get('appointerResidenceStateCode')?.value;
    this.selectedAppointmentWith.appointerResidenceStateLicenseId = this.appointerForm.get('appointerResidenceStateLicenseId')?.value;
    this.selectedAppointmentWith.appointerResidenceStateCompanyId = this.appointerForm.get('appointerResidenceStateCompanyId')?.value;
    this.resetFormData(false);
  });
  // }
}

openConfirmationPopup(){
  var modalData = {
    title: 'Discard Changes',
    prompt: 'Your changes will be lost. Continue?',
  };

  const modalRef = this.modalService.open(ConfirmDialogComponent, ngbModalOptions);
  modalRef.componentInstance.modalData = modalData;
  modalRef.componentInstance.buttonText = 'Yes';
  modalRef.componentInstance.buttonClass = 'basic-btn';
  modalRef.componentInstance.buttonText1 = 'No';
  modalRef.componentInstance.buttonClass1 = 'primary-btn';

  modalRef.result.then((data) => {
    if (data) {
      if(this.isPopupView){
        this.closePopup.next(true);
      }else{
        this.targetLink('edit-carrier');
      }
    }
  });
}

  get zipCodeControl() {
  return this.appointerForm.get('zip');
}

formatZipCode(event: Event): void {
  const input = event.target as HTMLInputElement;
  const value = input.value.replace(/\D/g, ''); // Remove non-digit characters
  if(value.length <= 5) {
  this.zipCodeControl?.setValue(value);
} else {
  const formatted = `${value.slice(0, 5)}-${value.slice(5, 9)}`;
  this.zipCodeControl?.setValue(formatted);
}
  }

ngOnDestroy(): void {
  this.subscription.forEach(t => { t.unsubscribe() })
}
}
